// Shared utility functions for user and producer management

/**
 * Get default producer for filters based on current user
 * @param {Object} user - Current user object
 * @param {Array} producers - Available producers list
 * @returns {string} Default producer filter value
 */
export const getDefaultProducerFilter = (user, producers = []) => {
  if (!user) return "All Producers";

  for (let i in producers) {
    if (producers[i].id === parseInt(user.id)) {
      return producers[i].id;
    }
  }
  return user.id;
};

/**
 * Get producer display name (username + country with capitalized first letter)
 * @param {Object} producer - Producer object with username and location/country
 * @returns {string} Formatted producer name
 */
export const getProducerName = (producer) => {
  if (!producer) return '';
  // Capitalize first letter of username and add country
  const capitalizedUsername = producer.username.charAt(0).toUpperCase() + producer.username.slice(1).toLowerCase();
  const country = producer.location || producer.country || 'US'; // Default to US if no country specified
  return `${capitalizedUsername} ${country}`;
};